import { render, staticRenderFns } from "./ead-area.vue?vue&type=template&id=b423faf8&scoped=true&"
import script from "./ead-area.vue?vue&type=script&lang=js&"
export * from "./ead-area.vue?vue&type=script&lang=js&"
import style0 from "./ead-area.vue?vue&type=style&index=0&id=b423faf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b423faf8",
  null
  
)

export default component.exports